import { AxiosError } from "axios";
import AjexPortalService from "./api";
import config from './config';
import { getNotificationStyle } from '../common/notification';
import { IdleVehiclePayload, RouteDeviationPayload } from '../components/DashboardComponent/DriverDashboard/interface';

const commonUrl = process.env.REACT_APP_TMS_COMMON_SERVICE;
const bookingURL = process.env.REACT_APP_API_BOOING_SERVICE_BASE_URL;
const notificationUrl = process.env.REACT_APP_TMS_NOTIFICATION_URL;

const vehicleNotificationAlert = config.get("vehicleNotificationAlert");
const getIdleVehicleStates = config.get("getIdleVehicleStates");

export const setNotificationTokenService = async (payload) => {
    try {
        return await AjexPortalService.post(`${commonUrl}user-device`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
};
export const deleteNotificationTokenService = async (payload) => {
    try {
        return await AjexPortalService.post(`${bookingURL}vehicle/un-assign`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
};

export const getNotificationListService = async (payload: RouteDeviationPayload) => {
    try {
        const { page, size } = payload;
        return await AjexPortalService.post(`${notificationUrl}${vehicleNotificationAlert}/search?page=${page}&size=${size}`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response)
        return err?.response;
    }
};

export const getIdealVehiclesService = async (payload: IdleVehiclePayload) => {
    try {
        return await AjexPortalService.post(`${notificationUrl}${vehicleNotificationAlert}/${getIdleVehicleStates}`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response)
        return err?.response;
    }
};

export const getNotificationTypesService = async () => {
    try {
        return await AjexPortalService.get(`${notificationUrl}${vehicleNotificationAlert}/notificationTypes`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response)
        return err?.response;
    }
};

